<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <a class="navbar-brand" href="#">{{'NavBar.Translation' | translate}}</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
    <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
      @if (features.textTranslation) {
        <li class="nav-item active">
          <a class="nav-link" routerLink="/text-translation">{{'NavBar.Text' | translate}}</a>
        </li>
      }
      <li class="nav-item">
        <a class="nav-link" routerLink="/file-upload">{{'NavBar.Files' | translate}}</a>
      </li>
      @if (features.textRephrase) {
        <li class="nav-item">
          <a class="nav-link" routerLink="/text-rephrase">{{'NavBar.Rephrase' | translate}}</a>
        </li>
      }
      <li class="nav-item">
        <a class="nav-link" target="glossar" href="https://across.bizerba.com/crosstermweb/crossTermWeb.dll?">{{'NavBar.Glossary' | translate}}</a>
      </li>
    </ul>
  </div>
  <div class="dropdown">
    <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
      <i class="bi bi-translate"></i>{{selectedLanguage}}
    </button>
    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
      @for (key of languages | keyvalue; track key) {
        <li>
          <a class="dropdown-item" (click)="switchLanguage(key.key)">{{key.value}}</a>
        </li>
      }
    </ul>
  </div>
</nav>
